import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RolesRoutingModule } from './roles-routing.module';
import { ManageRoleComponent } from './components/manage-role/manage-role.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CreateRoleComponent } from './components/create-role/create-role.component';
import { ListRolesComponent } from './list-roles/list-roles.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { PrimengLibraryModule } from 'primeng-library';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    ManageRoleComponent,
    CreateRoleComponent,
    ListRolesComponent
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    TableModule,
    AccordionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatSelectModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatTabsModule,
    RolesRoutingModule,
    MatIconModule,
    FormsModule,
    PrimengLibraryModule,
    MatExpansionModule,
    NgxPermissionsModule.forChild()
  ],
  exports: [ListRolesComponent, ManageRoleComponent]
})
export class RolesModule { }
